import React from "react";
import { socialMediaData } from "../config/dataConfig";
import { Tooltip } from "./Tooltip";
import "../App.scss";
const SubscribeForm = ({ isDark = false }) => {
  return (
    <div
      className={`subscribe-form text-center mx-auto p-4"
        }`}
      style={{
    borderTop: "1px solid rgba(255, 255, 255, 0.29)",   // Only top border
    // opacity:"0.5",
    color: "#fff",
    maxWidth: "600px",
    marginTop: "4rem"
  }}
    >
      <h6 className="fw-bold mb-2" style={{ color: "#fff",marginTop:"14px" }}>
       Want early access?
      </h6>
      <p className="follow-line">
        Follow us on our social media handles for the official announcement.
      </p>
      <ul className="social-icons social-icons-light d-flex justify-content-center">
        {socialMediaData.length > 0 &&
          socialMediaData.map((value, index) => (
            <li className={value.class} key={index}>
              <Tooltip text={value.name} placement="top">
                <a
                  data-bs-toggle="tooltip"
                  href={value.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={value.name}
                >
                  <i className={value.icon} />
                </a>
              </Tooltip>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default SubscribeForm;
